import { render, staticRenderFns } from "./dollar.vue?vue&type=template&id=79250f84&scoped=true&"
import script from "./dollar.vue?vue&type=script&lang=js&"
export * from "./dollar.vue?vue&type=script&lang=js&"
import style0 from "./dollar.vue?vue&type=style&index=0&id=79250f84&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79250f84",
  null
  
)

export default component.exports